<template>
  <div>
    <div class="p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ObjectivesCompetence",
  data() {
    return {
      columns: [
        { field: "Competency", key: "a", title: "Competency" },
        { field: "Description", key: "b", title: "Description" },
        { field: "DueDate", key: "c", title: "Due Date" },
      ],
      tableData: [
        {
          Competency: "Agility",
          Description: "Lorem erat volutpat. Sed ut dui ut lacus dictum fermentum vel tincidum fermentum vel tincidu",
          DueDate: "15 Dec 2022",
        },
      ],
    };
  },
};
</script>
